import React from 'react';

import clsx from 'clsx';

import {
  FileInput,
  Paper,
  Grid,
  Typography,
  View,
  makeStyles,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px dashed ${theme.palette.action.disabled}`,
    borderRadius: '4px',
    width: '100%',
    height: '156px',
  },
  highlight: {
    borderColor: `${theme.palette.text.disabled}`,
    backgroundColor: `${theme.palette.action.hover}`,
  },
}));

const UploadFile = ({ onDropFile, onChooseFile, loading }) => {
  const classes = useStyles();
  const [highlight, setHighlight] = useMountedState(false);

  const handleChooseFile = async (e, files) => {
    let copy = [...files];
    e.persist();
    e.target.value = '';
    await onChooseFile(copy[0]);
  };

  const handleDropFile = async (_e, files) => {
    let copy = [...files];
    await onDropFile(copy[0]);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
    handleDropFile(e, e.dataTransfer.files);
  };
  return (
    <Paper
      variant={'outlined'}
      style={{ padding: '8px' }}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
    >
      <View loading={loading}>
        <Grid
          container
          direction={'column'}
          className={clsx(classes.root, {
            [classes.highlight]: highlight,
          })}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {!loading ? (
            <Grid direction={'column'} item spacing={2}>
              <Grid item p={1}>
                <Typography variant={'h6'} sx={{ textAlign: 'center' }}>
                  Drop File Here
                </Typography>
              </Grid>
              <Grid item>
                <FileInput
                  label={'Choose file'}
                  accept={'.xlsx'}
                  variant={'outlined'}
                  onUpload={handleChooseFile}
                  multiple={false}
                />
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </View>
    </Paper>
  );
};

export default UploadFile;
